import * as React from "react"

function SvgCheckCircle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 34 34"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.083}
      >
        <path d="M24.813 10.488l-9.115 12.37-6.51-5.208" />
        <path d="M2.026 16.999a14.974 14.974 0 1029.948 0 14.974 14.974 0 00-29.948 0h0z" />
      </g>
    </svg>
  )
}

export default SvgCheckCircle
